import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const startAeoOnboarding = unaryRpc({
  name: "startAeoOnboarding",
  input: z.object({
    teamId: zExt.objectId(),
    numberOfPrompts: z.number().optional(),
  }),
  output: z.object({
    runId: z.string(),
    status: z.enum(["started", "already_running"]),
    workflowId: z.string(),
  }),
});
